export default function isRowProcessed(entry: any, quantity: any) {
  return {
    entry: entry,
    quantity: quantity,
  };
}
